// custom colors for components/web
export const componentsWebColors = {
  foxino: '#4656EF',

  foxinoOrange: {
    100: '#FFE8D2',
    200: '#FFD1A5',
    300: '#FFAE62',
    400: '#FF9C41',
    500: '#FF8B1F',
    600: '#FF8413'
  },
  primary: {
    100: '#F5F4FF',
    200: '#E1DEFF',
    300: '#C3BDFF',
    400: '#7164E9',
    500: '#6153D0',
    600: '#4D4693',
    700: '#342B6F',
    800: '#2B2759',
    900: '#24224A',
    1000: '#1C1A3F',
    1050: '#191739',
    1100: '#14122C',
    1150: '#0D0C1F',
    1200: '#0E0D20'
  },
  secondary: {
    100: '#FFF1D4',
    200: '#FFE2A9',
    300: '#FFD47E',
    400: '#FFC654',
    500: '#FFB627',
    600: '#F7A400',
    700: '#C58300',
    800: '#946300',
    900: '#634200',
    1000: '#312100'
  },
  success: {
    100: '#E0F8E8',
    200: '#C1F2D2',
    300: '#A2EBBB',
    400: '#82E5A5',
    500: '#65DE8F',
    600: '#37D56E',
    700: '#25B156',
    800: '#1C8541',
    900: '#13582B',
    1000: '#092C16'
  },
  error: {
    100: '#FDD8E0',
    200: '#FBB1C0',
    300: '#F98BA1',
    400: '#F76481',
    500: '#F53E64',
    600: '#F20D3B',
    700: '#C20A2F',
    800: '#910823',
    900: '#610517',
    1000: '#30030C'
  },
  neutral: {
    100: '#FCFCFD',
    200: '#F3F3F6',
    300: '#E8E8EE',
    400: '#D3D2DB',
    500: '#9F9DAE',
    600: '#504D61',
    700: '#403850',
    800: '#221F37',
    900: '#141127',
    1000: '#0F0D1C'
  }
}
